/**
 * Date-extensions locale Danish [da]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('da', {
    monthNames: ['Januar','Februar','Marts','April','Maj','Juni','Juli','August','September','Oktober','November','December'],
    monthShortNames: ['Jan','Feb','Mar','Apr','Maj','Jun','Jul','Aug','Sep','Okt','Nov','Dec'],
    dayNames: ['Søndag','Mandag','Tirsdag','Onsdag','Torsdag','Fredag','Lørdag'],
    dayShortNames: ['Søn','Man','Tir','Ons','Tor','Fre','Lør']
});
